import { callApi } from 'helpers/saga-helpers';
import { setExpertExpertiseMissions } from 'containers/ExpertAssignedMissions/actions';
import { select, takeLeading } from '@redux-saga/core/effects';
import { REQUEST_EXPERT_EXPERTISE_MISSIONS } from 'containers/ExpertAssignedMissions/constants';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
export function* fetchExpertiseMessions(action: any): Generator<unknown> {
  const path = `/corporeal/mission?status=[${action.payload}]&isIntervenant=true`;

  const token: any = yield select(makeSelectKeycloakToken());

  if (!token) return;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, [], options, [], setExpertExpertiseMissions);
}

export function* fetchExpertiseMissionsSaga() {
  yield takeLeading(REQUEST_EXPERT_EXPERTISE_MISSIONS, fetchExpertiseMessions);
}

export default [fetchExpertiseMissionsSaga];
